import React from 'react';

import MainController from "./MainController";
import {formatNumber} from "../../helpers/formatHelper";

function MainView(props) {
    const {method, state} = MainController(props);
    return (
        (state.isLoad) && <>
            <div className="product-info_actions_options">
                <div className="product-info_actions_price">
                    {(state.product?.priceSale != "0" && parseFloat(state.product?.priceSale) > parseFloat(state.price)) &&
                        <span className="product-info_actions_price__old">{state.product?.priceSale}đ</span>}
                    <span className="product-info_actions_price__new">{state.price}đ</span>
                </div>
            </div>
            <div className="product-info_actions_lead">
                <p className="product-info-action__desc" dangerouslySetInnerHTML={{__html: state.product?.lead}} title={state.product?.lead}/>
            </div>
            <div>
                <div className="product-info_actions_social">
                    <button className="btn btn-facebook" onClick={method.shareFace}><i
                        className="fa-brands fa-facebook"></i> <span>Chia sẻ</span>
                    </button>
                </div>
            </div>
            <div className="product-info_actions_orders">
                {
                    (state.product?.productProperties?.length > 0) && (
                        <div className="product-info_actions_orders__variations">
                            {
                                state.product?.productProperties?.map(item => {
                                    let listV = item?.productPropertieValue ?? [];
                                    return (
                                        <div key={item.id} className="product-info_actions_orders__variation">
                                            <label>{item.name}</label>
                                            <div className="product-info_actions_orders__variation-items">
                                                {
                                                    listV.length > 0 && listV.map(itemV => {
                                                        return (
                                                            <div key={itemV.id} className="product-info_actions_orders__variation-item">
                                                                <input type="radio" checked={method.isChecked(item.id, itemV.id)}
                                                                       id={"p_" + itemV.id} name={item.id} value={itemV.id}
                                                                       onChange={method.selectProperties}/>
                                                                <label htmlFor={"p_" + itemV.id}>{itemV.value}</label>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )
                }
                <div className="product-info_actions_orders__amount">
                    <label>Số lượng</label>
                    <div className="product-info_actions_orders__amount_groups">
                        <div className="product-info_actions_orders__amount_groups_form">
                            <span className="product-info_actions_orders__amount_groups_form_decrease"
                                  onClick={(e) => method.clickQuantityBuy(1)}>
                                <i
                                    className="fa-solid fa-minus">
                                </i>
                            </span>
                            <input type="number" enterKeyHint="done"
                                   className="product-info_actions_orders__amount_groups_form_input"
                                   onChange={method.changeQuantityBuy} value={state.quantityBuy} min={0} max={1000}/>
                            <span
                                className="product-info_actions_orders__amount_groups_form_increase"
                                onClick={(e) => method.clickQuantityBuy(2)}>
                                <i
                                    className="fa-solid fa-plus">
                                </i>
                            </span>
                        </div>
                    </div>
                </div>
                {
                    (state.err) && (
                        <div className="product-info_actions_orders_message">
                            <span>{state.err}</span>
                        </div>
                    )
                }
                <div className="product-info_actions_orders__actions">
                    <button className="btn btn-card btn-custom-default" type={"button"}
                            onClick={(e) => method.saveCart(e)} disabled={state.disable}>
                        Thêm vào giỏ hàng &nbsp;<i className="fa-solid fa-cart-shopping d-none d-md-inline-block"></i>
                    </button>
                    <button className="btn btn-buy btn-custom-default" type={"button"} onClick={method.saveOrder}
                            disabled={state.disable}>Mua ngay
                    </button>
                </div>
            </div>
        </>
    )
}

export default MainView;